import * as React from 'react';
import { t } from 'i18next';

import { HamburgerTab } from '../../constants/Enums';
import { BaseHamburgerTab } from './BaseHamburgerTab';
import { PconLoginStore } from '../../stores/PconLoginStore';
import { ViewSettingsStore } from '../../stores/ViewSettingsStore';
import { ProjectManagerStore } from '../../stores/ProjectManagerStore';
import { LayoutType } from '../../constants/LayoutConstants';
import { BrowserProjectButtons } from './BrowserProjectButtons';
import { LongButton } from '../LongButton';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { DebugStore } from '../../stores/DebugStore';
import { HamburgerFooter } from './HamburgerFooter';
import { PRODUCT_NAME } from '../../App';

import utils = egr.wcf.utils;

interface HamburgerNavigationState {
    userName: string;
    hamburgerTab: HamburgerTab | null;
    loadedProjectName: string;
}

export class HamburgerNavigation extends BaseHamburgerTab<HamburgerNavigationState> {
    protected previous: HamburgerTab = HamburgerTab.MENU;

    public componentWillMount(): void {
        this.addStoreListener(PconLoginStore, this.onChange);
        this.addStoreListener(ViewSettingsStore, this.onChange);
        this.addStoreListener(ProjectManagerStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        let projectLabel: string = t('Project');
        if (utils.string.isNotNullOrEmpty(this.state.loadedProjectName) && this.props.layoutType === LayoutType.SMALL) {
            projectLabel += ' - ' + this.state.loadedProjectName;
        }
        return (
            <div className="hamburger-tab navigation">
                <div className="sidebar-content">
                    <div className="hamburger-tab-header hamburger-tab-header-navigation" key="hamburger-header">{projectLabel}</div>
                    <BrowserProjectButtons/>
                    <div className="popup-spacer" key="popup-spacer"/>
                    <div className="long-button-group popup-buttons">
                        {DebugStore.getState().enabled ?
                            <LongButton
                                active={(this.state.hamburgerTab === HamburgerTab.DEBUG)}
                                icon="settings-button"
                                shortBorder={false}
                                onClick={() => {ViewSettingsActions.changeHamburger(HamburgerTab.DEBUG); }}
                            >
                                Debug
                            </LongButton> :
                            null}
                        <LongButton
                            arrow={false}
                            active={(
                                this.state.hamburgerTab === HamburgerTab.SETTINGS ||
                                this.state.hamburgerTab === HamburgerTab.SETTINGS_IMAGE ||
                                (
                                    this.state.hamburgerTab === HamburgerTab.MENU &&
                                    (true && this.props.layoutType !== LayoutType.SMALL)
                                )
                            )}
                            icon="settings-button"
                            shortBorder={false}
                            onClick={() => {ViewSettingsActions.changeHamburger(HamburgerTab.SETTINGS); }}
                        >
                            {t('Settings')}
                        </LongButton>
                    </div>
                    <HamburgerFooter userLanguage={this.props.userLanguage} key={this.props.userLanguage}/>
                </div>
            </div>
        );
    }

    protected getLabel(): string {
        return PRODUCT_NAME;
    }

    protected onChange = (): void => {
        this.setState({
            userName: PconLoginStore.isLoggedIn() ? PconLoginStore.getUserName() : '',
            hamburgerTab: ViewSettingsStore.getState().hamburgerTab,
            loadedProjectName: ProjectManagerStore.getCurrentProjectName(''),
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/HamburgerNavigation.tsx